import motorbike from '../../../common/images/revamp/icon/motorbike.svg';
import star from '../../../common/images/revamp/icon/star.svg';
import { ChevronRightIcon, ClockIcon } from '@heroicons/react/24/solid';
import OutletByLocation from '../../Outlet/Location';
import { MathRandom, sendAnalyticsCustomEvent, sendAnalyticsEvent, checkTime, checkHoldTime, trackMetaPixelEvent, isEmptyData } from '../../../utils/helper';
import NoOutlet from '../../Outlet/NoOutlet';
import { LoaderIcon, PinPointIcon } from '../../../utils/svg';
import ImageLoader from '../../ImageLoader';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetOutletPagination, resetOutletByLocation, resetLoadingOtherLocation, setOpenOtherLocation } from '../../../store/reducers/outlet';
import { useHistory } from 'react-router-dom';
import { useState } from 'react';
import { CouponVoucherGlobal } from '../../VoucherGlobal';
import SearchProduct from '../../Search/List/Product';

const OutletPromotion = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const { list: outlets, isOpenOtherLocation, isLoadingOtherLocation, isLoadMore, loading, selectedStoreID } = useSelector((state) => state.outlet);
	const user = useSelector((state) => state.user);
	const [selectedBrandID, setSelectedBrandID] = useState(null);
	const [openOtherLocation, setOpenOtherLocationState] = useState(false);

  const reset = useRef(false);

	const handleOutletByLocationClick = async (item = null) => {
		setSelectedBrandID(item ?? null);
		setOpenOtherLocationState(true);
	};

	const handleOutletByLocationCloseClick = async () => {
		dispatch(resetOutletByLocation());
		setSelectedBrandID(null);
		setOpenOtherLocationState(false);
	};

	const handleClickOutlet = (item) => {
		if (item?.storeOpen === '1') {
			history.push({
				pathname: `/outlet/${item?.storeSlug}/delivery`,
				state: {
					storeID: item?.storeID,
					storeSlug: item?.storeSlug,
					storeName: item?.storeName,
					storeImage: item?.storeImage,
					rating: item?.rating,
					bannerImage: item?.storeBannerImage,
				},
			});
		}
	};

	useEffect(() => {
		sendAnalyticsCustomEvent('view_merchants_list', {
			merchants_list_id: 'related_products',
			merchants_list_name: 'Related products',
			items: outlets,
		});
		trackMetaPixelEvent('view_merchants_list', {
			merchants_list_id: 'related_products',
			merchants_list_name: 'Related products',
			items: outlets,
		});
	}, []);

  useEffect(() => {
    if (reset.current) return;
    reset.current = true;
  	dispatch(resetLoadingOtherLocation());
		dispatch(resetOutletPagination());
  }, []);

	useEffect(() => {
		if (isOpenOtherLocation) return;
		dispatch(resetOutletByLocation());
	}, [isOpenOtherLocation]);

	useEffect(() => {
		const unblock = history.block((location, action) => {
			if (action === 'POP') {
				dispatch(setOpenOtherLocation(false));
				return false;
			}
			return true;
		});
		return () => {
			unblock();
		};
	}, [isOpenOtherLocation, history]);

	return (
		<div className='w-full px-4 mb-10 space-y-[26px] max-w-lg h-full max-h-full !overflow-y-scroll scrollbar-hide overflow-x-hidden z-0'>
			{loading &&
				new Array(6).fill('').map((item, index) => (
					<div key={index} className='flex justify-between gap-3'>
						<div className='rounded-lg bg-[var(--pin-ball)] animate-pulse w-[95px] h-[95px]'></div>
						<div className='grow space-y-1'>
							<div className='rounded-sm bg-[var(--pin-ball)]  animate-pulse h-[21px] max-w-full' style={{ width: `${MathRandom(80, 200)}px` }}></div>
							<div className='rounded-sm bg-[var(--pin-ball)]  animate-pulse h-[21px] w-16 max-w-full'></div>
							<div className='rounded-sm bg-[var(--pin-ball)]  animate-pulse h-[21px] max-w-full' style={{ width: `${MathRandom(60, 90)}px` }}></div>
							<div className='rounded-sm bg-[var(--pin-ball)]  animate-pulse h-[21px] w-36 max-w-full'></div>
						</div>
					</div>
				))}

			{outlets?.map((item, index) => {
				const distance = parseFloat(item?.distance || 0)?.toFixed('2');
				const isBusy = item?.endHold && checkHoldTime(item?.endHold);
				const outletStatus = isBusy ? `Resto sedang sibuk` : `Tutup${item?.outletOpenTime ? ` - Buka pukul ${item?.outletOpenTime} ${checkTime(item?.outletOpenTime)} hari ini` : ''}`;
        const searchProductProps = {
          products: item?.products,
          storeSlug: item?.storeSlug,
          storeOpen: item?.storeOpen,
          outOfDelivery: item?.outOfDelivery,
          className: `!pl-0 ${isEmptyData(item?.products) && 'hidden'}`
        }
				return (
					<div key={item?.id || index} className={`flex flex-col ${!isEmptyData(item?.products) && 'gap-3'}`}>
						<div className='flex space-x-3'>
							<div
								className='aspect-[1/1] h-[110px] w-[110px] cursor-pointer'
								onClick={() => {
									if (item?.outOfDelivery) return;
									sendAnalyticsEvent('Click Outlet', 'homepage_select_outlet', item?.storeName);
									handleClickOutlet(item);
								}}
								id='homepage_select_outlet'>
								<ImageLoader src={item?.storeImage} alt={item?.storeImage} />
							</div>
							<div className='grow'>
								<div
									onClick={() => {
										if (item?.outOfDelivery) return;
										handleClickOutlet(item);
									}}
									className='grow space-y-1'>
									<div className={`${item?.storeOpen === '0' ? 'flex' : 'hidden'} items-center`}>
										<ClockIcon class='h-4 w-4 text-red-500 mr-1' />
										<div className='text-xs font-normal text-gray-900'>{outletStatus}</div>
									</div>
									<div className={`${item?.outOfDelivery && item?.storeOpen === '1' ? 'flex' : 'hidden'} items-center`}>
										<PinPointIcon className={'stroke-red-500 text-red-500 fill-red-500 mr-1'} />
										<div className='text-xs font-normal text-orange-700'>Diluar Jangkauan Pengiriman</div>
									</div>
									<p className={`mb-0 !mt-0 font-semibold text-sm cursor-pointer ${item?.storeOpen === '0' || item?.outOfDelivery ? 'text-gray-400' : 'text-[var(--dark-gray)]'} line-clamp-1 max-w-[calc(100vw-139px)]`}>
										{item?.storeName}
									</p>
									<div className='flex gap-3 items-center !mt-0'>
										{item?.rating && (
											<div className='flex items-center gap-1'>
												<img src={star} alt='star' />
												<span className='font-medium text-xxs text-[var(--dark-gray)]'>
													{item?.rating || 0} ({item?.totalRating || 0})
												</span>
											</div>
										)}
										<div className='flex items-center gap-1'>
											<img src={motorbike} alt='motorbike' />
											<span className='text-xxs'>{distance} km</span>
										</div>
									</div>
								</div>
								<div
									id='homepage_see_other_outlets'
									className='inline-flex gap-2 mt-1 items-center py-1.5 px-2 bg-[var(--rose-violet-opacity)] text-[var(--rose-violet)] rounded-full cursor-pointer min-w-36 justify-between text-xxs'
									onClick={() => handleOutletByLocationClick(item)}>
									<div className='w-full flex justify-center'>{isLoadingOtherLocation && selectedStoreID === item?.storeID ? <LoaderIcon /> : 'Cek lokasi lainnya'}</div>
									<ChevronRightIcon className='text-[var(--rose-violet)] w-3 h-auto' />
								</div>
								{item?.storeOpen === '1' && <CouponVoucherGlobal vouchers={item?.voucher_global || []} item={item} handleClick={(item) => handleClickOutlet(item)} />}
							</div>
						</div>
						<SearchProduct {...searchProductProps} />
					</div>
				);
			})}
			{openOtherLocation && selectedBrandID?.brandID ? (
				<OutletByLocation isOpen={openOtherLocation} onClose={() => handleOutletByLocationCloseClick()} latitude={user?.latitude} longitude={user?.longitude} outletSelected={selectedBrandID} />
			) : !isLoadingOtherLocation && openOtherLocation ? (
				<NoOutlet isOpen={isOpenOtherLocation} onClose={() => dispatch(setOpenOtherLocation(false))} />
			) : null}
			{isLoadMore && (
				<div className='flex justify-center !mt-1'>
					<LoaderIcon />
				</div>
			)}
		</div>
	);
};

export default OutletPromotion;
